import { render, staticRenderFns } from "./Vue.Extend.vue?vue&type=template&id=7533997c&"
import script from "./Vue.Extend.vue?vue&type=script&lang=js&"
export * from "./Vue.Extend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports